/**
 * AWS and API Configuration
 * 
 * In a production environment, these values should be loaded from environment variables
 * using process.env.VARIABLE_NAME and not hardcoded in the source code.
 * 
 * For local development, you can use .env files with create-react-app.
 */

// AWS S3 Configuration
export const S3_CONFIG = {
  region: process.env.REACT_APP_AWS_REGION || 'YOUR_AWS_REGION', // e.g., 'us-east-1'
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID || 'YOUR_ACCESS_KEY_ID',
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY || 'YOUR_SECRET_ACCESS_KEY',
  bucketName: process.env.REACT_APP_S3_BUCKET_NAME || 'YOUR_BUCKET_NAME'
};

// API Configuration
export const API_CONFIG = {
  uploadNotificationEndpoint: process.env.REACT_APP_UPLOAD_NOTIFICATION_API || 'YOUR_API_ENDPOINT',
  apiKey: process.env.REACT_APP_API_KEY || 'YOUR_API_KEY' // If your API requires an API key
};

// File Upload Configuration
export const UPLOAD_CONFIG = {
  maxFileSizeMB: 10, // Maximum file size in MB
  allowedFileTypes: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel', // .xls
    'text/csv' // .csv
  ],
  s3FolderPrefix: 'spend-analytics/' // Prefix for S3 folder structure
}; 